import Image from "next/image";
import { ChatType, ConditionName, IChatCardProps, IChatDefaultMessages } from "../../../../../interfaces";
import { useAppSelector } from "../../../../../redux/hooks";
import { conditions, getRemainingTime } from "../../../../../helpers";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";
import IMAGES from "images";

const EmptyProfileIcon = dynamic(() => import("../../icon-components/emptyProfile"));

const ChatCard = ({ message }: IChatCardProps) => {
    const { usersInfoInChat, chatType, defaultMessages } = useAppSelector(
        ({ chats: { usersInfoInChat, chatType, defaultMessages } }) => ({ usersInfoInChat, chatType, defaultMessages }),
        shallowEqual
    );
    const { userId } = useAppSelector(({ user: { userId } }) => ({ userId }), shallowEqual);

    let user: any = undefined;
    if (message.isConfirmed === undefined) user = usersInfoInChat.find((user: any) => user.id === message.author);

    let userImage = <></>;
    if (user && Object.keys(user).length > 0 && user.image)
        userImage = <Image src={user.image} width={24} height={24} alt="user-profile" className="pl-rounded-full" />;
    else if (message.avatar_url) userImage = <Image src={message.avatar_url} width={24} height={24} alt="user-profile" className="pl-rounded-full" />;
    else userImage = <EmptyProfileIcon />;

    let username: any = <></>;
    if (user && Object.keys(user).length > 0) username = user.displayName;
    else if (message.name) username = message.name;
    else username = "کاربر ناشناس";

    let confirm = <></>;
    if (chatType !== ChatType.public && message.isConfirmed !== undefined && userId === message.author) {
        if (!message.isConfirmed) {
            confirm = (
                <div className="pl-flex pl-items-center pl-gap-1 pl-mr-auto">
                    <Image src={IMAGES.clock} width={15} height={17} />
                    <p className="pl-text-[9px] pl-font-normal pl-text-orange-700 dark:pl-text-orange-200">در انتظار تایید توسط ادمین</p>
                </div>
            );
        } else if (defaultMessages.filter((msg: IChatDefaultMessages) => msg.message === message.text).length === 0) {
            confirm = (
                <div className="pl-flex pl-items-center pl-gap-1 pl-mr-auto">
                    <Image src={IMAGES.greenTick} width={15} height={15} />
                    <p className="pl-text-[9px] pl-font-normal pl-text-z-green">تایید شده توسط ادمین</p>
                </div>
            );
        }
    }

    return (
        <>
            <div
                className={`pl-flex pl-items-center pl-gap-1 pl-font-normal ${
                    conditions(ConditionName.isTouchScreen) ? "pl-text-[11px]" : "pl-text-[14px]"
                }`}
            >
                {userImage}
                <p className="pl-text-main-highLight pl-text-[14px] pl-font-normal">{username} .</p>
                <span className="pl-text-z-secondary-600 dark:pl-text-z-gray-400 pl-text-[9px]">{getRemainingTime(message.created_at)}</span>
                {confirm}
            </div>
            <p className="pl-text-[13px] pl-font-normal pl-text-z-gray-700 dark:pl-text-secondary-50 pl-break-words">{message.text}</p>
        </>
    );
};

export default ChatCard;
